import { Button, List, Progress } from "antd";
import Modal from "antd/lib/modal/Modal";
import React, { useEffect, useState } from "react";
import { FC } from "react";
import Form from "../../../../components/ui/form";
import { connect, ConnectedProps, useDispatch } from "react-redux";
import { IGlobalReducerState } from "../../../../store/base/interface/IGlobalReducerState";
import styles from './ImportadorAcompanhamento.module.scss';
import { toast } from "react-toastify";
import { secondsToMs } from "../../../../utils/dateHelper";
import { IAcompanhamento } from "../../../../data/interfaces/acompanhamento/IAcompanhamento";
import { IImportAcompanhamentoRequest } from "../../../../data/interfaces/acompanhamento/IAcompanhamentoRequest";
import { AcompanhamentoActions } from "../../../../store/acompanhamento/Acompanhamento.actions";

export interface IImportadorAcompanhamento {
    industriaId: number;
    ano: number;
    mes: number;
    visible: boolean;
    onClose: (reload?: boolean) => void;
}

const ImportadorAcompanhamento: FC<Props> = (props) => {
    const dispatch = useDispatch();
    const [isSubmit, setIsSubmit] = useState(false);
    const [file, setFile] = useState<File | null>(null);
    const [timeUpdating, setTimeUpdating] = useState(0);
    const [isUpdating, setIsUpdating] = useState<boolean>(false);
    const [showForm, setShowForm] = useState<boolean>(true);
    const [tipoOrigem, setTipoOrigem] = useState<string>('importar');

    useEffect(() => {
        if (isUpdating) {
            setTimeout(() => {
                setTimeUpdating(timeUpdating + 1);
            }, 1000);
        }
    }, [timeUpdating, isUpdating])

    useEffect(() => {
        if (!props.isImporting && isUpdating) {
            if (!props.errosImportacao || props.errosImportacao?.length == 0) {
                onClose(true);
                setShowForm(true);
            }

            setIsUpdating(false);
        }
    }, [props.isImporting])

    const onSelectFile = (e: FileList | null) => {
        if (e) {
            setFile(e[0]);
        }
    }

    const onClose = (reload?: boolean) => {
        setFile(null);
        props.onClose(reload);
    }

    const submit = (values: IImportAcompanhamentoRequest) => {
        if (values) {
            if (tipoOrigem == 'importar' && file == null) {
                toast.error('Selecione um arquivo para importar');
            }
            else {
                values.file = file;
                values.industriaId = props.industriaId;
                values.ano = props.ano;
                values.mes = props.mes;

                dispatch(AcompanhamentoActions.importarAcompanhamento(values));
                setIsUpdating(true);
                setShowForm(false);
            }
        }
        setIsSubmit(false);
    }

    const removeFile = () => {
        dispatch(AcompanhamentoActions.importarAcompanhamentoClear());
        setFile(null);
    }

    const downloadArquivoPadrao = () => {
        window.open(`${process.env.REACT_APP_BASE_API_URL}/Acompanhamento/DownloadArquivoPadrao`);
    }

    const buttons =
        [
            <Button hidden={!showForm} loading={props.isLoading} key="cancel" onClick={() => onClose()}>Cancelar</Button>,
            <Button hidden={!(showForm && props.errosImportacao && props.errosImportacao?.length > 0)} key="erros" danger onClick={() => setShowForm(false)}>Ver Erros</Button>,
            <Button hidden={!showForm} key="submit" type="primary" loading={props.isLoading} onClick={() => setIsSubmit(true)}>{'Importar'}</Button>,
            <Button hidden={showForm} key="back" type="primary" loading={props.isLoading} onClick={() => setShowForm(true)}>{'Voltar para Importação'}</Button>,
            <Button hidden={!showForm} key='downloadFile' type='link' style={{ position: 'absolute', left: 10 }} onClick={downloadArquivoPadrao}>Baixar arquivo padrão</Button>,
        ];

    const errosAtualizacao = <List
        header={<b>Erros da Importação</b>}
        bordered
        dataSource={props.errosImportacao}
        renderItem={item => (
            <List.Item>
                {item.message}
            </List.Item>
        )}
    />;

    const form =
        <Form onSubmit={submit} isSubmited={isSubmit} className={styles['form']}>
            <div className={styles['groupSelect']} style={{ display: "flex" }} hidden={tipoOrigem != 'importar'}>
                <div className={styles['upload']}>
                    {
                        file ?
                            <div className={styles['fileSelected']}>
                                <div className={styles['fileName']}>{file.name}</div>
                                <div title='Remover arquivo' className={styles['clearFile']} onClick={removeFile} >X</div>
                            </div>
                            :
                            <div className={styles['selectFile']} onClick={() => document.getElementById('fileImportar')?.click()}>Selecionar Arquivo</div>
                    }
                    <input type='file' id='fileImportar' hidden onChange={(e) => onSelectFile(e.currentTarget.files)} />
                </div>
            </div>
        </Form>;

    const infoAtualizacao = <div className={styles['infoUpdating']} id='infoUpdating'>
        <p>Importando - <span>{secondsToMs(timeUpdating)}</span></p>
        <Progress
            strokeColor={{
                from: '#108ee9',
                to: '#87d068',
            }}
            percent={100}
            showInfo={false}
            status="active"
        />
    </div>;

    return (
        <Modal title={'Importação Acompanhamento'} open={props.visible} footer={!isUpdating ? buttons : null} closable={false} destroyOnClose={true} width={!showForm && props.errosImportacao && props.errosImportacao.length > 0 ? 750 : 450}>
            <div className={styles['container']}>
                {
                    isUpdating ?
                        infoAtualizacao :
                        (
                            !showForm && props.errosImportacao && props.errosImportacao.length > 0 ?
                                errosAtualizacao
                                : form
                        )}
            </div>
        </Modal>
    );
}

const mapState = (state: IGlobalReducerState) => ({
    ...state.acompanhamento
});

const connector = connect(
    mapState,
);

type PropsFromRedux = ConnectedProps<typeof connector>;
type Props = PropsFromRedux & IImportadorAcompanhamento;

export default connector(ImportadorAcompanhamento);